import { ProductDetailInsert, ProductDetailDelete, ProductDetailUpdate, ProductDetailGetById, ProductDetailGetList, ProductDetailGetPageList } from "@/api/productdetail/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    ProductDetailInsert(context, payload) {
        return new Promise((resolve, reject) => {
            
            
            ProductDetailInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    ProductDetailUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            ProductDetailUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    ProductDetailGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            ProductDetailGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    ProductDetailGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            ProductDetailGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    ProductDetailGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            ProductDetailGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}